export enum PaymentOption {
    PayNow = "PAY_NOW",
    PayLater = "PAY_LATER",
}
  